import { render, staticRenderFns } from "./WxChartDoughnutGraph.vue?vue&type=template&id=aeabf040&scoped=true"
import script from "./WxChartDoughnutGraph.vue?vue&type=script&lang=js"
export * from "./WxChartDoughnutGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeabf040",
  null
  
)

export default component.exports